import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  alternativeOfferForUnOnly,
  orderEligibilitiesMockEligibleToRefundWithUnOneWay,
  orderForUnOneWayOnly,
} from '../../../mock/data';
import {
  flightDisruptionWarning,
  orderNotEligibleForRefundWarning,
} from '../../../mock/dictionaries';

export const unOnlyOneWayMock: MockMap = {
  retrieveOrder: [createMockData(orderForUnOneWayOnly, [], [flightDisruptionWarning])],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleToRefundWithUnOneWay, [], [orderNotEligibleForRefundWarning])],
  getAlternativeOffers: [createMockData(alternativeOfferForUnOnly)]
};
